"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var ResizeGroup_base_1 = require("./ResizeGroup.base");
var ResizeGroup_styles_1 = require("./ResizeGroup.styles");
exports.ResizeGroup = Utilities_1.styled(ResizeGroup_base_1.ResizeGroupBase, ResizeGroup_styles_1.getStyles);
//# sourceMappingURL=ResizeGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/ResizeGroup/ResizeGroup.js
// module id = 871
// module chunks = 0